import { StyleSheet } from 'aphrodite';
import { white } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';
import { THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	button: {
		color: white,
		position: 'relative',
		background: THEME.colors.primary.main,

		transition: 'color .5s, background-color .5s',
		alignItems: 'center',
		borderRadius: 8,
		display: 'flex',
		fontSize: 14,
		fontFamily: THEME.typography.fontFamilies.lexend,
		justifyContent: 'center',
		textAlign: 'center',
		gap: 8,
		boxSizing: 'border-box',
		textDecoration: 'none',
		padding: '10px 16px',

		':has(*) > svg': {
			display: 'block',
			pointerEvents: 'none',
			flexShrink: 0,
			width: 16,
			height: 16,
		},
		'::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			background: `linear-gradient(to right, ${THEME.colors.primary.main}, ${THEME.colors.tertiary.dark})`,
			opacity: 1,
			transition: 'opacity 0.3s ease-in-out',
			zIndex: 0,
			borderRadius: 8,
		},
		':hover': {
			'::before': {
				opacity: 0,
			},
		},
		...CssSelectors.allChildren(
			{
				zIndex: 1,
			},
			'*'
		),
	},
	default: {
		height: 36,
	},
	sm: {
		height: 32,
	},
	xs: {
		height: 27,
		padding: '4px 14px',
	},
});
